import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import TagManager from 'react-gtm-module';
import * as Sentry from '@sentry/react';

import { store } from './redux/store.js';
import './assets/styles/index.scss';
import App from './App.jsx';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const GTM_ID = import.meta.env.VITE_GTM_ID;

Sentry.init({
  dsn: SENTRY_DSN,
  sendDefaultPii: true,
  tracesSampleRate: 0.05,
});

TagManager.initialize({
  gtmId: GTM_ID,
});

createRoot(document.getElementById('root'), {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>,
);
